import _ from 'lodash'

import api from '@/api/api'
import Routes from '@/router/routes'

import HTTP from '@/components/general/http/http'
import ScrollTo from '@/components/general/scroll-to/scroll-to'
import TextField from '@/components/general/fields/text/text'

export default {
	name : 'login',
	data () {
		return {
			form : {
				fields : {
					username : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('public.login.fields.username'),
						type    : 'text',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 4,
							maxLength : 100,
							required  : true
						}
					},
					password : {
						id      : _.uniqueId('field_'),
						display : true,
						value   : '',
						name    : this.$t('public.login.fields.password'),
						type    : 'password',
						error   : false,
						filters : {
							type      : 'string',
							minLength : 4,
							maxLength : 100,
							required  : true
						}
					}
				},
				active : false
			}
		}
	},
	methods : {
		formSubmit () {

			let vm = this

			if( vm.form.active ){

				return

			}

			vm.form.active = true

			setTimeout(() => {

				vm.$root.$emit('validate', [vm.form.fields, (response) => {

					if( !response.success ){

						vm.form.active = false

						response.type = 'error'
						
						response.field.error = true

						let dataToScroll = {
							selector : '#' + response.field.id,
							target   : 'html, body'
						}

						ScrollTo.submit(dataToScroll)

						vm.$root.$emit('showMessage', response)

						return

					}

					let dataToSend = {
						username : vm.form.fields.username.value,
						password : vm.form.fields.password.value
					}

					api
						.authentication
						.login(dataToSend)
						.then( (response) => {

							vm.form.active = false

							if( response.status != 200 ){

								let message = {
									message : [vm.$t('errors.custom.001')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

								return

							}

							if( !response.data.success ){

								if( response.data.error.code == 101 ){

									let message = {
										message : [vm.$t('errors.parse.101')],
										type    : 'error'
									}

									vm.$root.$emit('showMessage', message)

								}

								return

							}

							let route = ''

							if( route == '' && response.data.user.permissions.sellers ){

								route = Routes.sellersList.name

							}

							if( route == '' && response.data.user.permissions.clients ){

								route = Routes.clientsList.name

							}

							if( route == '' && response.data.user.permissions.contracts ){

								route = Routes.contractsList.name

							}

							if( route == '' && response.data.user.permissions.masterData ){

								route = Routes.reportsMasterData.name

							}

							if( route == '' && response.data.user.permissions.reports ){

								route = Routes.reportsSDA.name

							}

							if( route == '' ){

								let message = {
									message : [vm.$t('errors.custom.006')],
									type    : 'error'
								}

								vm.$root.$emit('showMessage', message)

								return

							}

							localStorage.setItem('sessionToken', response.data.user.sessionToken)
							localStorage.setItem('sessionUser', JSON.stringify( response.data.user ) )

							vm.$router.push({name : route})

						});

				}])

			}, 1000)

		}
	},
	components : {
		TextField
	}
}



// WEBPACK FOOTER //
// ./src/components/public/login/script.js